// extracted by mini-css-extract-plugin
module.exports = {"grid_cell1":"document-panel-bar-entities_grid_cell1__1DosY","grid_headerCell1":"document-panel-bar-entities_grid_headerCell1__3GWKn"};